/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CreateMasterAccountRequest extends models.MasterAccountBase {
    getFixupPrototypeFunction() { return CreateMasterAccountRequest.fixupPrototype; }

    static newInstance(model: Partial<CreateMasterAccountRequest>): CreateMasterAccountRequest {
        let obj = Object.assign(new CreateMasterAccountRequest(), model);
        CreateMasterAccountRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CreateMasterAccountRequest>): CreateMasterAccountRequest {
        if (!model) return null;
        return CreateMasterAccountRequest.newInstance(<CreateMasterAccountRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CreateMasterAccountRequest) {
        if (!obj) return;

        models.CreateMasterAccountRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CreateMasterAccountRequest): boolean {
        if (models.MasterAccountBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CreateMasterAccountRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.third_party_subscription_details) {
            models.ThirdPartySubscription.fixupPrototype(this.third_party_subscription_details);
        }
    }

    /**
     * Name of the master account. It can be only alphanumeric
     */
    name: string;

    /**
     * Tenant name. It can be only alphanumeric
     */
    tenant_name: string;

    /**
     * SSO tenant id
     */
    sso_tenant_id: string;

    /**
     * Third party subscription details
     */
    third_party_subscription_details: models.ThirdPartySubscription;

}
